import { t } from 'i18n';
import cloneDeep from 'lodash.clonedeep';
/**
 * Translate if the value is array
 * If the item is object, keep translating its children
 * @param array - the array to be translated
 * @returns void
 */
const handleArray = (array: any[]): void => {
  array.forEach((item) => {
    if (typeof item === 'string') {
      item = translateStr(item);
    } else {
      _doTranslate(item);
    }
  });
};

/**
 * Translate if the value is object
 * If the item is object, keep translating its children
 * @param obj - the obj to be translated
 * @returns void
 */
const handleObject = (obj: any): void => {
  for (const key in obj) {
    if (typeof obj[key] === 'string') {
      obj[key] = translateStr(obj[key]);
    } else {
      _doTranslate(obj[key]);
    }
  }
};

/**
 * Do translate the complex object (with nested arrays and nested objects inside)
 * @param obj - the input object
 * @returns void
 */
function _doTranslate(obj: any): void {
  const isObj = typeof obj === 'object';
  if (!isObj) return;

  return Array.isArray(obj) ? handleArray(obj) : handleObject(obj);
}

/**
 * translate string
 * Note: not translate if it's url link, tel, mail
 * @param value - the value needs to be translated
 * @returns the translated string
 */
function translateStr(value: string): string {
  return !(
    value.includes('http') ||
    value.includes('tel:') ||
    value.includes('mailto:')
  )
    ? t(value)
    : value;
}

/**
 * Translate the complex object (with nested arrays and nested objects inside)
 * by checking the absolute key path with the regex
 * @param originalObject - the input object
 * @returns the translated object
 */
export function translateComplexObject(originalObject: any): any {
  const result = cloneDeep(originalObject);
  _doTranslate(result);
  return result;
}
